module.exports = __webpack_public_path__ + "img/L_320_326.21e1f4dc.png";